import React, { useEffect, useState } from 'react'
import PageMessage from 'ppbl/components/PageMessage'
import { getLocalizedText } from 'ppbl/utils/locale-helper'
import { merge } from 'lodash-es'
import { BodyText, Link } from '@paypalcorp/pp-react'
import { interpolate } from 'ppbl/utils/string-helper'
import { navigate } from '@reach/router'
import { redirectToServerRoute } from 'ppbl/utils/common-utils'
import { trackClick, trackPage } from 'ppbl/utils/fpti-helper'
import { FPTI_EVENTS } from 'ppbl/utils/fptiEventNames'
import { useApplicationContext } from 'ppbl/hooks'
import clientLogger from 'ppbl/utils/client-logger'
import serverData from 'ppbl/utils/server-data'
import { CaseTypes, sessionTimeoutPageConstants } from 'ppbl/utils/constants'
import { getPortalUrl } from 'ppbl/screens/__utils__'

type Props = {
  applicationType: string
}

const fptiData = {
  page: 'sessionTimeoutPage',
  event_name: FPTI_EVENTS.PAGE.SESSION_TIMEOUT,
}

const SessionTimeoutPage: React.FC<Props> = ({ applicationType }) => {
  const { data } = useApplicationContext()
  const portalInfo = data?.applicationMetaData?.portalAccess
  const [pageType, setPageType] = useState('preOffer')

  useEffect(() => {
    const pageTypePostOffer =
      sessionStorage.getItem('mostRecentCompletedPage') === 'offer' &&
      'postOffer'
    if (pageTypePostOffer) {
      setPageType(pageTypePostOffer)
    }
    clientLogger.info(
      'Session Timeout page is loaded - Application ID:',
      data?.applicationMetaData?.applicationId,
    )
    trackPage(
      merge(fptiData, {
        applicationId: data?.applicationMetaData?.applicationId,
      }),
    )
  }, [])

  const onclick = () => {
    trackClick(
      merge(fptiData, {
        component: 'restartApplication_button',
        link: 'restartApplication_button',
        applicationId: data?.applicationMetaData?.applicationId,
        event_name: FPTI_EVENTS.CLICK.NAVIGATION.ERROR_RESTART,
      }),
    )
    if (applicationType === 'app') {
      redirectToServerRoute(
        `/merchant-lending/loanbuilder/${applicationType}/start`,
      )
    } else if (
      applicationType === 'app-renewal' ||
      applicationType === 'paypal-renewal'
    ) {
      navigate(`${serverData.data.appConfig.application?.portalUrlFallback}`)
    } else if (applicationType === 'paypal') {
      window.location.assign('/merchant-lending/loanbuilder/login')
    }
  }

  const handleLoginClick = () => {
    const portalUrl = getPortalUrl(portalInfo, CaseTypes.DEFAULT)
    window.open(portalUrl, '_self')
  }

  return (
    <>
      <PageMessage
        type={pageType === 'preOffer' ? 'error' : 'warning'}
        onPrimaryAction={pageType === 'preOffer' ? onclick : handleLoginClick}
        localization={{
          title: getLocalizedText('sessionTimeout-page.title'),
          primaryText:
            pageType === 'preOffer'
              ? getLocalizedText('sessionTimeout-page.restartButton')
              : getLocalizedText('sessionTimeout-page.loginButton'),
        }}
      >
        <BodyText className="body__text">
          {pageType === 'preOffer' ? (
            <>{getLocalizedText('sessionTimeout-page.preOfferBodyText')}</>
          ) : (
            <>
              {getLocalizedText('sessionTimeout-page.postOfferBodyText1')}
              <br />
              <br />
              {interpolate(
                getLocalizedText('sessionTimeout-page.postOfferBodyText2'),
                {
                  contact: (
                    <Link
                      href={sessionTimeoutPageConstants.phoneNumber.tel}
                      secondary
                    >
                      {sessionTimeoutPageConstants.phoneNumber.phone}
                    </Link>
                  ),
                },
              )}
              <br />
              <br />
              {getLocalizedText('sessionTimeout-page.postOfferBodyText3')}
            </>
          )}
        </BodyText>
      </PageMessage>
    </>
  )
}

export default SessionTimeoutPage
